export const Red = '#E82121';
export const Green = '#00ad50';

const ButtonStyle = ({ color = Green }) => ({
    boxShadow: 'none',
    width: 150,
    height: 30,
    textTransform: 'none',
    fontSize: 16,
    lineHeight: "20px",
    padding: 0,
    fontWeight: "bold",
    backgroundColor: color,
    fontFamily: "Proxima Nova",
    '&:hover': {
        backgroundColor: color,
        boxShadow: 'none',
    },
    '&:active': {
        backgroundColor: color,
        boxShadow: 'none',
    },
    '&:focus': {
        backgroundColor: color,
        boxShadow: 'none',
    },
    '&:disabled': {
        color: 'white',
        boxShadow: 'none',
    },
});

const callPatient = theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
    },
    modalWrapper: {
        outline: "none",
        height: 360,
        width: 570,
        left: 60,
        overflow: "hidden",
        position: "relative",
        border: "1px solid #979797",
        borderRadius: 4,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        boxShadow: "10px 10px 10px 0 rgba(0,0,0,0.5)"
    },
    modalHeader: {
        maxHeight: 24,
        display: "flex",
        flex: 1,
        backgroundColor: "#d2dcdd",
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 16,
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        paddingLeft: 13,
        alignItems: "center"
    },
    modalBody: {
        display: "flex",
        minWidth: '540px',
        flexDirection: "column",
        paddingLeft: 18,
        paddingRight: 18,
        paddingTop: 20
    },
    contentWrapper: {
        display: "flex",
        alignItems: "center",
    },
    contentWrapperNoAlign: {
        display: "flex",
        flex: "1",
        lineHeight: "initial",
    },
    orderNote: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        letterSpacing: 0,
        lineHeight: "17px",
        marginRight: 20,
    },
    boldText: {
        fontWeight: "bold"
    },
    ConnectionMessage: {
        color: "green",
        fontFamily: "Proxima Nova",
        fontSize: 14,
        letterSpacing: 0
    },
    marginDetails: {
        marginBottom: "15px"
    },
    CallPatientDetails: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: 24,
        marginTop: "7px",
        letterSpacing: 0,
        fontWeight: "bold"
    },
    mainTitleText: {
        color: "#242424",
        width: "95px",
        fontSize: 14,
        fontFamily: "Proxima Nova",
        fontWeight: "bold",
        lineHeight: "30px",
        letterSpacing: "0"
    },
    dFlex: {
        display: "flex"
    },
    marginTop10: {
        marginTop: 10
    },
    marginTop6: {
        marginTop: 6
    },
    marginTop_7: {
        marginTop: -7
    },
    phoneInputText: {
        flex: "1",
        marginRight: "20px",
        height: 30
    },
    errorMessage: {
        display: "flex",
        flexDirection: "inherit",
        fontSize: 12,
        marginTop: "10px",
        marginBottom: "20px",
        color: "red"
    },
    noErrorMessage: {
        display: "flex",
        flexDirection: "inherit",
        fontSize: 12,
        marginTop: "10px",
        marginBottom: "20px"
    },
    textInput: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        padding: "4px 10px",
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 30,
        paddingTop: 5,
        resize: "none",
        border: "1px solid #979797",
        boxSizing: "border-box",
        outline: "none",
        whiteSpace: "pre",
        "overflow-wrap": "normal",
        "overflow-x": "scroll"
    },
    textInputError: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        padding: "4px 10px",
        paddingTop: 5,
        backgroundColor: "white",
        lineHeight: "17px",
        flexGrow: 1,
        height: 30,
        resize: "none",
        border: "1px solid red",
        boxSizing: "border-box",
        outline: "none",
        whiteSpace: "pre",
        "overflow-wrap": "normal",
        "overflow-x": "scroll"
    },
    buttonStyle: ButtonStyle({ color: Green }),
    buttonStyleWithMarginRight: {
        ...ButtonStyle({ color: Green }),
        marginRight: 20
    },
    cancelButtonStyle: {
        boxShadow: 'none',
        width: 150,
        height: 30,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: "20px",
        padding: 0,
        border: "1px solid #4d4d4d",
        color: "#242424",
        fontWeight: "bold",
        backgroundColor: 'white',
        fontFamily: "Proxima Nova",
        '&:hover': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:active': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: 'white',
            boxShadow: 'none',
        },
    },
    modalActionWrapper: {
        display: "flex",
        flex: 1,
        justifyContent: "flex-end",
        alignItems: "flex-end",
        marginBottom: 15
    },
    modalCloseWrapper: {
        display: "flex",
        flexDirection: 'column',
        marginBottom: 15,

        '& .call-summary-wrapper': {
            display: 'flex',
            marginBottom: 10,
        },

        '& .call-summary-close-wrapper': {
            display: 'flex',
            flexDirection: 'row-reverse'
        }
    },
    yourPhoneWrapper: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    }
})

export default callPatient;